var _circle, _circle2, _rect, _polygon, _polygon2, _polygon3, _polygon4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _ellipse, _rect11, _rect12, _rect13, _polygon5, _polygon6, _rect14, _polygon7, _polygon8, _path, _polygon9, _path2, _path3, _path4, _path5, _circle3, _polygon10, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle4, _circle5, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 590.81881,
    height: 646.93595,
    viewBox: "0 0 590.81881 646.93595",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 119.02093,
    cy: 512.16388,
    r: 14.92017,
    fill: "#f0f0f0",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.40748,
    cy: 519.28992,
    r: 10.46638,
    fill: "#f0f0f0",
    style: {
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112.91481,
    cy: 50,
    r: 12,
    fill: "#ccc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.91481,
    cy: 190,
    r: 12,
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111.91481,
    y: 277,
    width: 20,
    height: 20,
    fill: "#ccc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "8.915 130 6.915 130 6.915 0 134.915 0 134.915 2 8.915 2 8.915 130",
    fill: "#ccc"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "590.819 130 588.819 130 588.819 2 462.819 2 462.819 0 590.819 0 590.819 130",
    fill: "#ccc"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.915 240 6.915 240 6.915 370 134.915 370 134.915 368 8.915 368 8.915 240",
    fill: "#ccc"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "590.819 240 588.819 240 588.819 368 462.819 368 462.819 370 590.819 370 590.819 240",
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.91481,
    y: 61,
    width: 140,
    height: 2,
    fill: "#ccc"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80.91481,
    y: 43,
    width: 2,
    height: 18.5,
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 141.91481,
    y: 43,
    width: 2,
    height: 18.5,
    fill: "#ccc"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 420.91481,
    y: 202,
    width: 140,
    height: 2,
    fill: "#ccc"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 458.91481,
    y: 184,
    width: 2,
    height: 18.5,
    fill: "#ccc"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 519.91481,
    y: 184,
    width: 2,
    height: 18.5,
    fill: "#ccc"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 51.91481,
    y: 296,
    width: 140,
    height: 2,
    fill: "#ccc"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 89.91481,
    y: 278,
    width: 2,
    height: 18.5,
    fill: "#ccc"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 150.91481,
    y: 278,
    width: 2,
    height: 18.5,
    fill: "#ccc"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.80709,
    cy: 405.43595,
    rx: 56,
    ry: 13,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 592.3237,
    y: 663.46816,
    width: 54.14795,
    height: 1.99957,
    transform: "translate(-351.90571 -79.04478) rotate(-4.22916)",
    fill: "#cacaca"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 565.3979,
    y: 649.55525,
    width: 1.99957,
    height: 22.82544,
    transform: "translate(-590.30121 712.18978) rotate(-61.18921)",
    fill: "#cacaca"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 290.80709,
    y: 520.93595,
    width: 18,
    height: 2,
    fill: "#cacaca"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "243.805 646.004 241.809 645.868 256.809 416.868 258.805 417.004 243.805 646.004",
    fill: "#cacaca"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.808 645.985 307.808 434.985 309.806 434.887 319.806 645.887 317.808 645.985",
    fill: "#cacaca"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 649.89755,
    y: 542.07622,
    width: 2.00037,
    height: 230.78345,
    transform: "translate(-356.50794 -70.71426) rotate(-4.72229)",
    fill: "#cacaca"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "274.807 645.96 272.807 645.912 278.807 434.912 280.807 434.96 274.807 645.96",
    fill: "#cacaca"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "265.236 513.691 251.954 521.557 215.29 474.07 234.894 462.459 265.236 513.691",
    fill: "#ffb6b6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M580.83992,651.09122l-42.82736,25.3656-.32085-.54169a19.375,19.375,0,0,1,6.79577-26.54258l.00106-.00063,26.15755-15.49235Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#2f2e41"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "329.378 513.691 342.66 521.557 379.324 474.07 359.721 462.459 329.378 513.691",
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M633.14928,633.87957l26.15754,15.49235.00106.00063a19.375,19.375,0,0,1,6.79578,26.54258l-.32085.54169-42.82736-25.3656Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M643.09657,459.032s-43.33516,30.52256-85.517,2.97925l-.65992,19.20056S466.56537,519.532,481.39768,549.468s46,61,46,61l17-14-19-48,51.68187-21.89452,45.05555.22679,62.82634,25.42864-30,45,26.43624,8.23909s63-58,49.5-74.5c-10.82077-13.22539-75.59448-42.878-75.59448-42.878Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M658.17747,347.05953l-37.50855-12.43378L611.39768,321.468h-27l-7.99951,13.366L541.6179,347.05953a7.99991,7.99991,0,0,0-5.686,9.04718L551.39768,483.468l25-2s33.68189,26.28192,54-4l1.085-15.27057,20.915,20.27057L663.8635,356.10671A7.9999,7.9999,0,0,0,658.17747,347.05953Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#2eaae6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M629.38,260.69161c-11.08984-18.7384-33.03021-19.61169-33.03021-19.61169s-21.37964-2.734-35.09454,25.80481c-12.78339,26.60052-30.42609,43.28387-2.84033,49.51086l4.98278-15.50867,3.08582,16.66327a107.9348,107.9348,0,0,0,11.80292.20172c29.54211-.95379,57.67651.27906,56.77063-10.3219C633.85282,293.33755,640.05064,278.7217,629.38,260.69161Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.30709,
    cy: 160.8549,
    r: 29,
    fill: "#ffb8b8"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.886 131.353 299.21 119.999 269.277 124.644 263.084 151.997 278.5 151.404 282.807 141.355 282.807 151.239 289.921 150.965 294.049 134.966 296.63 151.997 321.919 151.481 320.886 131.353",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M553.57955,374.532l22.5,87.991S565.57955,385.532,553.57955,374.532Z",
    transform: "translate(-304.5906 -126.53203)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.71582,463.523l22.5-87.991C631.21582,386.532,620.71582,463.523,620.71582,463.523Z",
    transform: "translate(-304.5906 -126.53203)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M625.95551,540.393a9.377,9.377,0,0,0,3.01578-14.05864L649.39768,470.468,633.7622,462.5082l-18.53953,62.542A9.42779,9.42779,0,0,0,625.95551,540.393Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#ffb6b6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M645.69234,369.0349l-22.78959,99.10187a4,4,0,0,0,2.99509,4.73322l21.94756,3.16215a4,4,0,0,0,4.87482-3.32253L659.39768,369.468Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#2eaae6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M573.83985,542.393a9.377,9.377,0,0,1-3.01577-14.05864L550.39768,472.468l15.63548-7.95977,18.53954,62.542A9.42779,9.42779,0,0,1,573.83985,542.393Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M554.103,371.0349l22.7896,99.10187a4,4,0,0,1-2.99509,4.73322L551.95,478.03214a4,4,0,0,1-4.87483-3.32253L538.39768,371.468Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#2eaae6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5906,773.468h-583a1,1,0,0,1,0-2h583a1,1,0,0,1,0,2Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#e4e4e4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M806.20134,669.31115l.74777-1.0657c12.83613,9.01269,22.19982,29.06012,27.831,59.58526a302.00917,302.00917,0,0,1,4.62271,43.161l-1.30224.02544C838.08532,770.21274,836.18663,690.36451,806.20134,669.31115Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#e4e4e4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M808.15471,726.92142l.74777-1.0657c13.38038,9.39421,14.19428,43.38225,14.2223,44.82438l-1.30224.02544C821.81618,770.359,820.99528,735.93666,808.15471,726.92142Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#e4e4e4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.17117,
    cy: 535.73506,
    r: 6.51122,
    fill: "#e4e4e4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 497.42678,
    cy: 592.38264,
    r: 6.51122,
    fill: "#e4e4e4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M831.25462,659.835a26.35787,26.35787,0,0,1-4.43136,28.30455,26.35787,26.35787,0,0,1,4.43136-28.30455Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#e4e4e4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M791.3977,683.66428a26.35793,26.35793,0,0,1,27.09944,9.29537,26.35788,26.35788,0,0,1-27.09944-9.29537Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#e4e4e4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M794.799,735.8418a18.47474,18.47474,0,0,1,18.99452,6.51531A18.47481,18.47481,0,0,1,794.799,735.8418Z",
    transform: "translate(-304.5906 -126.53203)",
    fill: "#e4e4e4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg-2.d04b26a7a34c0c0d0631c2da5393a5a0.svg";
export { ForwardRef as ReactComponent };